import { h, ComponentChildren } from "preact";

import classname from "../../../foundation/utils/classname";
import OverlayDialog from "../OverlayDialog";

import styles from "./Basic.module.css";

interface Props {
    title?: ComponentChildren;
    message: ComponentChildren;
    positiveButtonText?: string;
    negativeButtonText?: string;
    fallbackButtonText?: string;
    onPositiveButtonClick: () => void;
    onNegativeButtonClick?: () => void;
    onFallbackButtonClick?: () => void;
    hideNegativeButton?: boolean;
    onClose?: () => void;
    width?: number;
    loading?: boolean;
    class?: string;
}
/**
 * A basic dialog component with Title and Message
 */
function Basic({
    title,
    message,
    positiveButtonText,
    negativeButtonText,
    fallbackButtonText,
    onPositiveButtonClick,
    onNegativeButtonClick,
    onFallbackButtonClick,
    hideNegativeButton,
    onClose,
    width = 400,
    loading,
    class: cssClass
}: Props) {
    return (
        <OverlayDialog
            class={classname(styles.basicDialog, cssClass, { [styles.onlyMessage]: !title })}
            positiveButtonText={positiveButtonText}
            negativeButtonText={negativeButtonText}
            fallbackButtonText={fallbackButtonText}
            onPositiveButtonClick={onPositiveButtonClick}
            onNegativeButtonClick={onNegativeButtonClick}
            onFallbackButtonClick={onFallbackButtonClick}
            hideNegativeButton={hideNegativeButton}
            width={width}
            loading={loading}
            onClose={onClose}>
            <div class={styles.dialogBody}>
                {title && <h1 class={styles.title}>{title}</h1>}
                <div class={styles.message}>{message}</div>
            </div>
        </OverlayDialog>
    );
}

Basic.displayName = "BasicDialog";

export default Basic;
